module.exports = __webpack_public_path__ + "img/20200108160255377.a027d22e.jpg";